module.exports = ".not-found {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100vw;\n  height: 100vh; }\n  .not-found h1 {\n    color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/not-found/not-found.component.scss
// module id = ./src/app/shared/components/not-found/not-found.component.scss
// module chunks = main